import { TwoFAPinLength } from "@bundles/consts";
import { InputRef } from "antd";
import { useRef, useState } from "react";

export const use2FAFieldLogic = () => {
  const [pin, setPin] = useState<string[]>(Array(TwoFAPinLength).fill(""));
  const inputRefs = useRef<(InputRef | null)[]>(
    Array(TwoFAPinLength).fill(null)
  );

  const handleChange = (index: number, value: string) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    if (value && index < TwoFAPinLength - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleClearPin = () => {
    setPin(Array(TwoFAPinLength).fill(""));
  };

  const handleOverwritePin = (newPin: string[]) => {
    setPin(newPin);
  };

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    callback?: (pastedText: string) => void
  ) => {
    e.preventDefault();

    let pastedText = e.clipboardData.getData("text").trim().replace(/\D/g, "");

    if (pastedText.length > 6) {
      pastedText = pastedText.slice(0, 6);
    }

    let newPin = pastedText.split("");

    while (newPin.length < 6) {
      newPin.push("");
    }

    handleOverwritePin(newPin);

    if (/^\d{6}$/.test(pastedText)) {
      callback?.(pastedText);
    }
  };

  return {
    inputRefs,
    pin,
    handleChange,
    handleKeyDown,
    handleClearPin,
    handleOverwritePin,
    handlePaste,
  };
};
